import { gql } from '../../../artifacts/gql';

export const updateUserDefaultAddressMutation = gql(`
  mutation webUpdateUserDefaultAddressMutation($input: AccountUpdateInput!) {
    accountUpdate(input: $input) {
      successful
      messages {
        message
        code
      }
    }
  }
`);
